(function(){
  
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
  });

  /********REMOVING UNWANTED ELEMENTS ON DIFFERENT SCREEN********/
  // if(window.innerWidth >= 750){
  //   document.querySelectorAll(".desktop--hide")?.forEach(function(e){e.remove()});
  // }else{
  //   document.querySelectorAll(".mobile--hide")?.forEach(function(e){e.remove()});
  // }

  /******INSTAGRAM POST SLIDER*****/
  const igSwiper = new Swiper('.instragram--gallary', {
    spaceBetween: 16,
    slidesPerView: 1,
    freeMode: false,
    loop: true,
    centeredSlides: true,
    lazy: true,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      300: {
        slidesPerView: 1.3,
      },
      480: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });
  
  /*******REVIEWS SLIDER FUNCTIONALITY****/
  const reviewSlider = new Swiper(".review--slider",{
    // slidesPerView: 3,
    spaceBetween: 24,
    loop: true,
    centeredSlides : true,
    breakpoints: {
      320: {
        slidesPerView: 1.3,
        spaceBetween: 15
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 24
      },
      990: {
        slidesPerView: 3.3
      }
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  })

  /*******ANNOUCEMENT BAR SLIDER******/
  const annoucement_bar = new Swiper(".annoucement-swiper-slider",{
    loop: true,
    slidesPerView: 1,
    direction: "vertical",
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  }) 

  /*******ALIFBRICKS 3 SLIDER******/
  const alifBrickSlider = new Swiper(".alifbrick--3-slider",{
    slidesPerViews: 3,
    spaceBetween: 15,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        pagination: {
          enabled: true
        }
      },
      480: {
        slidesPerView: 2.1
      },
      750:{
        pagination: {
          enabled: false
        }
      },
      990: {
        slidesPerView: 3
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  })

  /******PRICE CHANGE ACCORDING TO BUNDLE*****/
  
  const activeBundler = document.querySelector("[bundle--box].active");
  if(activeBundler){
    if(activeBundler.classList.contains("choosable-bundle-product")){
      changePrice(activeBundler.querySelector("[bundle-choose-price]:not(.hidden)").innerHTML);
    }else{
      changePrice(activeBundler.querySelector("[bundle--product-price]").innerHTML);
    }
  }
  function changePrice(element){
    document.querySelector("[product--price--block]").innerHTML = element;
  }

  /****CHANGE ADD TO CART BUTTON BEHAVIOUR****/
  function buttonTextChange(foundElement){
    if(foundElement){
      bundleProductTrigger.setAttribute("disabled",true);
      bundleProductTrigger.querySelector("[add-to-cart-text]").innerHTML = theme.variantStrings.soldOut;
    }else{
      bundleProductTrigger.removeAttribute("disabled");
      bundleProductTrigger.querySelector("[add-to-cart-text]").innerHTML = theme.variantStrings.addToCart;
    }
  }
  function buttonChange(element){
    if(element.classList.contains("choosable-bundle-product")){
      const foundElement = element.querySelector("[bundle--chooseable].active").getAttribute("data-product-sold");
      buttonTextChange(foundElement);
    }else{
      const foundElement = element.getAttribute("data-product-sold");
      buttonTextChange(foundElement);
    }
  }
  /*******BUNDLE PRODUCT FUNCTIONALITY*****/
  const bundleBox = document.querySelectorAll("[bundle--box]");
  if(bundleBox.length){
    bundleBox.forEach(function(e){
      e.addEventListener("click",function(){
        document.querySelector("[bundle--box].active").classList.remove("active");
        this.classList.add("active");
        const priceElement = this.querySelector("[bundle--product-price]").innerHTML;
        changePrice(priceElement);
        buttonChange(this);
      })
    })
  }

  /*****BUNDLE CHOOSING TRIGGER AND FUNCTIONALITY*****/
  function changeBundle(element,foundElement,foundId){
    element.closest("[bundle--choose-main]").querySelector("[bundle--chooseable].active").classList.remove("active");
    foundElement.classList.add("active");
    element.closest("[bundle--box]").querySelector("[bundle--chooseable-price]:not(.hidden)").classList.add("hidden");
    element.closest("[bundle--box]").querySelector("[bundle--chooseable-price][data-id='"+foundId+"']").classList.remove("hidden");
    const priceElement = element.closest("[bundle--box]").querySelector("[bundle--chooseable-price][data-id='"+foundId+"']").innerHTML;
    changePrice(priceElement);
  }
  
  const bundlerChooseTrigger = document.querySelectorAll("[bundler--choose-trigger]");
  bundlerChooseTrigger.forEach(function(e){
    e.addEventListener("click",function(){
      const foundElement = this.closest("[bundle--choose-main]").querySelector("[bundle--chooseable]:not(.active)");
      const foundId = foundElement.dataset.id;
      changeBundle(this,foundElement,foundId);
      buttonChange(this.closest("[bundle--box]"));
    })
  })

  const bundleChooseable = document.querySelectorAll("[bundle--chooseable]");
  if(bundleChooseable.length > 0){
    bundleChooseable.forEach(function(e){
      e.addEventListener("click",function(){
        const foundId = this.dataset.id;
        changeBundle(this,this,foundId);
        buttonChange(this.closest("[bundle--box]"));
      })
    })
  }

  
  /*****BUNDLE ADD TO CART FUNCTIONALITY*****/
  // const bundleProductTrigger = document.querySelector("[bundleProductTrigger]");
  // if(bundleProductTrigger){
  //   bundleProductTrigger.addEventListener("click",function(){
  //     const activeBox = document.querySelector("[bundle--box].active");
  //     const trigger = this;
  //     if(activeBox){
  //       let activeBundle = "";
  //       if(activeBox.classList.contains("choosable-bundle-product")){
  //         activeBundle = activeBox.querySelector("[bundle--chooseable].active .bundle--product-id").value;
  //       }else{
  //         activeBundle = activeBox.querySelector(".bundle--product-id").value;
         
  //       }
  //       if(activeBundle){
  //         const miniCart = document.querySelector('mini-cart');
  //         trigger.setAttribute('disabled', true);
  //         trigger.classList.add('loading');
  //         const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
  //         const body = JSON.stringify({
  //           id: activeBundle,
  //           quantity: 1,
  //           sections: sections,
  //           sections_url: window.location.pathname
  //         });
    
  //         fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  //         .then((response) => response.json())
  //         .then((parsedState) => {
  //           if (parsedState.status === 422) {
  //              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
  //                 detail: {
  //                   errorMessage: parsedState.description
  //                 }
  //               }));
  //            }
  //            else {
  //             miniCart && miniCart.renderContents(parsedState);
  
  //              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
  //               detail: {
  //                 product: parsedState
  //               }
  //             }));
  //           }
  //         })
  //         .catch((e) => {
  //           console.error(e);
  //         })
  //         .finally(() => {
  //           trigger.classList.remove('loading');
  //           trigger.removeAttribute('disabled');
  //         });
  //       }
  //     }
  //   })
    
  // }

  
// varints click remove ready cart id class 

  //  const bundleProductTrigger_rem = document.querySelector(".product-form__input.variant-input-wrapper");
  // if(bundleProductTrigger_rem){
  //   bundleProductTrigger_rem.addEventListener("click",function(){
  //     var get_already_add_cart_id = document.querySelector('.variants_hidden_field');
  //     get_already_add_cart_id.classList.remove("ready_cart_id");
  //   });
  // }

      const cards = document.querySelectorAll('.combination-cards .card');
    cards.forEach((card) => {
      card.addEventListener('click', () => {
        cards.forEach((c) => c.classList.remove('active'));
        card.classList.add('active');
      });
    });
      var bundle_second_check = document.querySelector('.unique_second .custom-select-selected');
   const bundleProductTrigger = document.querySelector("[bundleProductTrigger]");
    var validation_check = document.querySelector('.custom-select-selectedl');
  var validation_check_sder = document.querySelector('.custom-select-containerl .custom-select-selectedl');
  var default_class_add_second = document.querySelector('.custom-select-container.unique_second');
  var addclass_add_val_second = document.querySelector(".unique_second .custom-select-selected");
  if(default_class_add_second.classList.contains('cta_default_second')){
    
  }
  if(bundleProductTrigger){ 
    console.log('yes');
    bundleProductTrigger.addEventListener("click",function (){
 
   if(bundle_second_check.classList.contains('active')){
     // alert('yes work');
   }
      if(validation_check.classList.contains('unlock_validation') && default_class_add_second.classList.contains('cta_default_second')){
        
        // alert('yes');

const selectedOption_first = document.querySelector('.unique_first .custom-select-options .selected_opt');
let first_bundle_qty = "";
let inputValue_first = ""; // Initialize inputValue_first to avoid undefined errors
if (selectedOption_first) {
    const inputElement = selectedOption_first.querySelector('.ready_cart_id');
    if (inputElement) {
        inputValue_first = inputElement.value; // Assign value to inputValue_first
        if (inputValue_first) {
            first_bundle_qty = 1;
        }
    }
}

const selectedOption_second = document.querySelector('.unique_second .custom-select-options .selected_opt');
let second_bundle_qty = "";
let inputValue_second = ""; // Initialize inputValue_second to avoid undefined errors
if (selectedOption_second) {
    const inputElement = selectedOption_second.querySelector('.ready_cart_id');
    if (inputElement) {
        inputValue_second = inputElement.value; // Assign value to inputValue_second
        if (inputValue_second) {
            second_bundle_qty = 1;
        }
    }
}

const selectedOption_third = document.querySelector('.unique_third .custom-select-options .selected_opt');
let third_bundle_qty = "";
let inputValue_third = ""; // Initialize inputValue_third to avoid undefined errors
if (selectedOption_third) {
    const inputElement = selectedOption_third.querySelector('.ready_cart_id');
    if (inputElement) {
        inputValue_third = inputElement.value; // Assign value to inputValue_third
        if (inputValue_third) {
            third_bundle_qty = 1;
        }
    }
}

const id_list = [inputValue_first, inputValue_second, inputValue_third];
const qty_list = [first_bundle_qty, second_bundle_qty, third_bundle_qty];


let empty_modify_array = id_list.filter(id => id !== ""); 
let empty_modify_qty_array = qty_list.filter((qty, index) => id_list[index] !== "");

console.log(empty_modify_array);
console.log(empty_modify_qty_array);
// Combine the two arrays and loop through them
  // for (let index = 0; index <= id_list.length; index++) {
  //   const id = id_list[index];
  //   const qty = qty_list[index];           

      // alert('yes');
      const activeBox = document.querySelector(".variants_hidden_field.ready_cart_id");
      const trigger = this;
      if(activeBox){
        let activeBundle = "";
          activeBundle = activeBox.value ;
          // alert(activeBundle);
        
        if(activeBundle){
          const miniCart = document.querySelector('mini-cart');
          console.log(miniCart);
          trigger.setAttribute('disabled', true);
          trigger.classList.add('loading');
          const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
          
          const body = JSON.stringify({
            id: empty_modify_array,
            quantity: 1,
            sections: sections,
            sections_url: window.location.pathname
          });
    
          fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status === 422) {
               document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                  detail: {
                    errorMessage: parsedState.description
                  }
                }));
             }
             else {
              miniCart && miniCart.renderContents(parsedState);
  
               document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: parsedState
                }
              }));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            trigger.classList.remove('loading');
            trigger.removeAttribute('disabled');
          });
        }
      }
      }
    else{
         bundle_second_check.classList.add('required_field_second');
         validation_check.classList.add('required_field');
         var pupop_box_fecth_main = document.querySelector('.set_cross_popup');
        var pupop_box_fecth = document.querySelector('.cta_popup_filed');
        pupop_box_fecth_main.classList.add('poup_show');
      
       if (validation_check.classList.contains('active')) {
    validation_check_sder.classList.remove('required_field');
}

      var validation_checker = document.querySelector('.custom-select-container.unique_second');
var validation_checkcta = document.querySelector('.custom-select-container.unique_second .custom-select-selected');

if (!validation_checker.classList.contains('cta_default_second')) {
    validation_checkcta.classList.add('required_field_lable');
}
 
    }  
    })
  
  }

//////Bundle settings////////////
  
     var remove_validation_second_cls = document.querySelector('.unique_second .custom-select-selected');
      var remove_validation_second_cls_gaoin = document.querySelector('.custom-select-container.unique_second');
  var validation_line_second = document.querySelector('.set_cross_popup');
         remove_validation_second_cls.addEventListener('click', () => {
           remove_validation_second_cls.classList.remove('required_field_lable');
           remove_validation_second_cls_gaoin.classList.add('cta_default_second');
           validation_line_second.classList.remove('poup_show');
         });
       
        document.querySelectorAll('.custom-select-container').forEach(container => {
          const selectedElement = container.querySelector('.custom-select-selected');
          const optionsContainer = container.querySelector('.custom-select-options');
          const options = container.querySelectorAll('.custom-select-option');
          const selectedImg = container.querySelector('#selected-img');
          const selectedTitle = container.querySelector('#selected-title');
          const optionsContainer_remove_pre = container.querySelectorAll('.custom-select-options');
          
        
          selectedElement.addEventListener('click', () => {
           selectedElement.classList.add('active_slected');
            selectedElement.classList.toggle('active');
            optionsContainer.classList.toggle('show');
          });
        
          options.forEach(option => {
            option.addEventListener('click', function () {
              
              options.forEach(opt => {
                const inputs = opt.querySelectorAll('input');
                inputs.forEach(input => input.classList.remove('ready_cart_id'));
                opt.classList.remove('selected_opt');
              });
        
              this.classList.add('selected_opt');
              const title = this.getAttribute('data-title');
              const image = this.getAttribute('data-image');
        
              if (selectedImg) selectedImg.src = image;
              if (selectedTitle) selectedTitle.textContent = title;
        
              optionsContainer.classList.remove('show');
        
              // Select all input elements within the clicked option
              const inputs = this.querySelectorAll('input');
              inputs.forEach(input => {
                const variantId = input.value;
                const variantName = input.getAttribute('data-name');
               
                // Match the selected variant
                const actualMatchVariants = document.querySelector('.product-form__input input[type=radio]:checked+label');
               
                if (actualMatchVariants) {
                  const vnametext = actualMatchVariants.innerText;
                  var empty_hide = vnametext.trim();
                  if (variantName === empty_hide) {
                    input.classList.add('ready_cart_id');
                  }
                }
              });
            });
          });
        });


    // Close dropdown when clicking outside
    // document.addEventListener('click', function (event) {
    //   if (!event.target.closest('.custom-select-container')) {
    //     optionsContainer.classList.remove('show');
    //   }
    // });
 
//////Language first settings////////////

const selectedContainerl = document.querySelector('.custom-select-selectedl');
const optionsContainerl = document.querySelector('.custom-select-optionsl'); // Fixed class name
const selectedImgl = document.getElementById('selected-imgl');
const selectedTitlel = document.getElementById('selected-titlel');
const selectedVariantInputl = document.getElementById('selected-variant');
const optionsl = document.querySelectorAll('.custom-select-optionl'); // Fixed class name
const remove_validation_text = document.querySelector('.set_cross_popup ');
  
// Toggle the visibility of the options container
selectedContainerl.addEventListener('click', () => {
  selectedContainerl.classList.toggle('active');
  selectedContainerl.classList.add('unlock_validation');
  optionsContainerl.classList.toggle('active'); // Fixed class name
});

// Handle option selection
optionsl.forEach(option => {
  option.addEventListener('click', function () {
    remove_validation_text.classList.remove('poup_show');
   selectedContainerl.classList.remove('required_field'); 
    const title = this.getAttribute('data-title');
    const image = this.getAttribute('data-image');
    const variantId = this.getAttribute('data-variant-id');

    // Update the selected container
    selectedImgl.src = image;
    selectedTitlel.textContent = title;
   
    // Close the options container
    optionsContainerl.classList.remove('active');

    // Update the hidden input value
    selectedVariantInputl.value = variantId;

    // Highlight the selected option
    optionsl.forEach(opt => opt.classList.remove('active'));
    this.classList.add('active');


const click_title_mt = title; 
const labels = document.querySelectorAll('.js.product-form__input.variant-input-wrapper label');


labels.forEach(label => {
    const all_current_variants = label.textContent.trim();
    if (all_current_variants === click_title_mt) {
        const correspondingInput = label.previousElementSibling; 
        if (correspondingInput) {
            correspondingInput.click(); 
        }

        // Select all '.selected_opt input' elements
        const agian_add_ready_click = document.querySelectorAll('.selected_opt input');
        
        // Remove the 'ready_cart_id' class from all inputs
        agian_add_ready_click.forEach(option_previous => {
            option_previous.classList.remove('ready_cart_id');
        });

        // Loop through inputs to find the matching option
        agian_add_ready_click.forEach(option_gr => {
            const get_seleted_option_input = option_gr.getAttribute('data-name');

            if (get_seleted_option_input === click_title_mt) {
                console.log(get_seleted_option_input); // Debugging output
                option_gr.classList.add('ready_cart_id'); // Add class to matching input
            }
        });
    }
});  
  });
});





////////////// disable bundle working start here

var first_set = document.querySelector(".set_build_one");
var second_set = document.querySelector(".set_build_two");
var third_set = document.querySelector(".set_build_three");

var builder_one = document.querySelector(".unique_first");
var builder_second = document.querySelector(".unique_second");
var builder_third = document.querySelector(".unique_third");

var set_two_click_remove = document.querySelector(".custom-select-container.unique_second");


first_set.addEventListener("click", ()=>{
  set_two_click_remove.classList.add('cta_default_second');
    builder_one.classList.remove("disabled");
    builder_second.classList.add("disabled");
    builder_third .classList.add("disabled");
})

second_set.addEventListener("click" ,()=>{
  builder_second.classList.remove("disabled");
    builder_third.classList.add("disabled");

  set_two_click_remove.classList.remove("cta_default_second");
})
third_set.addEventListener("click",()=>{
  set_two_click_remove.classList.add('cta_default_second');
    builder_one.classList.remove("disabled");
    builder_second.classList.remove("disabled");
    builder_third .classList.remove("disabled");
})


const options = document.querySelectorAll('.custom-select-option.selected_opt');
options.forEach(option => {
  option.click();
});


       const cardSetBuildTwo = document.querySelector('.set_build_two');
       cardSetBuildTwo.addEventListener("click", ()=>{
        var opt_click = document.querySelector('.unique_second .second_option_select_work');
        var event = new MouseEvent('click');
        opt_click.dispatchEvent(event);

                 var opt_click_th = document.querySelector('.unique_third .third_option_select_work');
        var eventone = new MouseEvent('click');
        opt_click_th.dispatchEvent(eventone);

// Select the span element
            var third_unselect_text_element = document.querySelector('.unique_third #selected-title');
            console.log(third_unselect_text_element.textContent);
            var unlock_three_set_get = document.querySelector('.unloac_set_three_cta').innerHTML;
            third_unselect_text = unlock_three_set_get;
            third_unselect_text_element.textContent = third_unselect_text;

        });

         const cardSetBuildThree = document.querySelector('.set_build_three');
       cardSetBuildThree.addEventListener("click", ()=>{
        // var opt_click_th = document.querySelector('.unique_third .third_option_select_work');
        // var event = new MouseEvent('click');
        // opt_click_th.dispatchEvent(event);

         document.querySelector('.unique_third .custom-select-options .custom-select-option:nth-child(4)').click();
            document.querySelector('.unique_second .custom-select-options .custom-select-option:nth-child(3)').click();


        });
    
         const cardSetBuildone = document.querySelector('.set_build_one');
       cardSetBuildone.addEventListener("click", ()=>{

        var opt_click = document.querySelector('.unique_second .second_option_select_work');
        var event = new MouseEvent('click');
        opt_click.dispatchEvent(event);

                 var opt_click_th = document.querySelector('.unique_third .third_option_select_work');
        var eventone = new MouseEvent('click');
        opt_click_th.dispatchEvent(eventone);
         
         // Select the span element
            var second_unselect_text_element = document.querySelector('.unique_second #selected-title');
            console.log(second_unselect_text_element.textContent);
         var unlock_second_set_get = document.querySelector('.unloac_set_second_cta').innerHTML;
            second_unselect_text = unlock_second_set_get;
            second_unselect_text_element.textContent = second_unselect_text
// Select the span element
            var third_unselect_text_element = document.querySelector('.unique_third #selected-title');
            console.log(third_unselect_text_element.textContent);
         var unlock_three_set_get_one = document.querySelector('.unloac_set_three_cta').innerHTML;
            third_unselect_text = unlock_three_set_get_one;
            third_unselect_text_element.textContent = third_unselect_text
       });

// var popup_cross_btn = document.querySelector('.set_cross_popup span');
// popup_cross_btn.addEventListener("click", ()=>{
// var remove_popup_hide = document.querySelector('.set_cross_popup');
// remove_popup_hide.classList.remove('poup_show');
// });
 




setTimeout(function(){
  // alert('yes');
    // Select the German and Dutch radio inputs
    const germanInput = document.querySelector('input[value="German"]');
    const dutchInput = document.querySelector('input[value="Dutch"]');
    var dutchDisableGenr = document.querySelector('.custom-select-optionsl');

    // Check if both inputs are disabled
    if (germanInput.disabled && dutchInput.disabled) {
         dutchDisableGenr.classList.add('remove_dutch_german');
        // alert('Both German and Dutch options are disabled.');
    }else{
        // alert('not_present')
    }
}, 1000);




          
})();